import { render, staticRenderFns } from "./material-file.vue?vue&type=template&id=449d87e2&scoped=true&"
import script from "./material-file.vue?vue&type=script&lang=js&"
export * from "./material-file.vue?vue&type=script&lang=js&"
import style0 from "./material-file.vue?vue&type=style&index=0&id=449d87e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449d87e2",
  null
  
)

export default component.exports